"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCourseWrapperMediator = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cccisdApollo = require("cccisd-apollo");
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdReactRouter = require("cccisd-react-router");
var _finalTestStatus = _interopRequireDefault(require("./finalTestStatus.graphql"));
var _externalRegistrationStatus = _interopRequireDefault(require("./externalRegistrationStatus.graphql"));
var _curriculumProgress = _interopRequireDefault(require("./curriculumProgress.graphql"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _curriculumResettableDeployments = _interopRequireDefault(require("./curriculumResettableDeployments.graphql"));
var _dateFns = require("date-fns");
var _index = require("./index.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var tabs = ['courseDescription', 'registration', 'course', 'finalTest', 'courseEval', 'certificate', 'resources'];
var Boilerplate = window.cccisd.boilerplate;
var useCourseWrapperMediator = exports.useCourseWrapperMediator = function useCourseWrapperMediator(_ref) {
  var _history$location;
  var actingPawnId = _ref.actingPawnId,
    actingPawnHash = _ref.actingPawnHash,
    basePath = _ref.basePath,
    handle = _ref.handle,
    curriculumRelatedDeploymentId = _ref.deploymentId,
    isPreviewMode = _ref.isPreviewMode,
    mediatorProps = _ref.mediatorProps,
    onAssignmentComplete = _ref.onAssignmentComplete,
    onComplete = _ref.onComplete,
    onFlowComplete = _ref.onFlowComplete,
    onFlowStarted = _ref.onFlowStarted,
    originalFlowList = _ref.originalFlowList;
  var certificate = mediatorProps.certificate,
    course = mediatorProps.course,
    courseDescription = mediatorProps.courseDescription,
    courseEval = mediatorProps.courseEval,
    finalTest = mediatorProps.finalTest,
    registration = mediatorProps.registration,
    resources = mediatorProps.resources;
  var history = (0, _cccisdReactRouter.useHistory)();
  var params = (0, _cccisdReactRouter.useParams)();
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    curriculumProps = _useState2[0],
    setCurriculumProps = _useState2[1];
  var _useState3 = (0, _react.useState)(_toConsumableArray(originalFlowList)),
    _useState4 = _slicedToArray(_useState3, 2),
    flowList = _useState4[0],
    setFlowList = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    hasVisitedCertificate = _useState6[0],
    setHasVisitedCertificate = _useState6[1];
  var _useState7 = (0, _react.useState)({
      summary: null,
      list: []
    }),
    _useState8 = _slicedToArray(_useState7, 2),
    finalTestData = _useState8[0],
    setFinalTestData = _useState8[1];
  // startedComplete is `true` after taking an external final test, so we
  // need a special flag to know if we finished before
  var _useState9 = (0, _react.useState)(true),
    _useState0 = _slicedToArray(_useState9, 2),
    finalTestStartedComplete = _useState0[0],
    setFinalTestStartedComplete = _useState0[1];
  var _useState1 = (0, _react.useState)({}),
    _useState10 = _slicedToArray(_useState1, 2),
    latestFinalTestData = _useState10[0],
    setLatestFinalTestData = _useState10[1];
  var _useState11 = (0, _react.useState)(0),
    _useState12 = _slicedToArray(_useState11, 2),
    finalTestDataRetrievedCount = _useState12[0],
    setFinalTestDataRetrievedCount = _useState12[1];

  // loading state to prevent automatically pushing to first tab until we
  // know which tab to start on. May have race condition bug with getCurrentTabs??
  var _useState13 = (0, _react.useState)(true),
    _useState14 = _slicedToArray(_useState13, 2),
    isExternalRegistrationLoading = _useState14[0],
    setIsExternalRegistrationLoading = _useState14[1];
  var _useState15 = (0, _react.useState)(false),
    _useState16 = _slicedToArray(_useState15, 2),
    isExternalRegistrationComplete = _useState16[0],
    setIsExternalRegistrationComplete = _useState16[1];
  var _useState17 = (0, _react.useState)(false),
    _useState18 = _slicedToArray(_useState17, 2),
    isExternalRegistrationCompleteLocally = _useState18[0],
    setIsExternalRegistrationCompleteLocally = _useState18[1];
  var showExternalRegistrationDeployment = registration && registration.toggle && registration.isExternalRegistration && !isExternalRegistrationComplete && !isExternalRegistrationCompleteLocally;
  var _useState19 = (0, _react.useState)(false),
    _useState20 = _slicedToArray(_useState19, 2),
    hasCompletedLocally = _useState20[0],
    setHasCompletedLocally = _useState20[1];
  var isRepeatedFinalTest = finalTest && finalTest.toggle && finalTest.useRepeatingFinalTest;
  var startedComplete = originalFlowList.filter(function (f) {
    return !f.isComplete;
  }).length === 0;
  var isCourseFullyComplete = isTabMediatorComplete('course');
  var isCourseEvalComplete = isTabMediatorComplete('courseEval');
  var isFinalTestComplete = isTabMediatorComplete('finalTest');
  var isRegistrationComplete = isTabMediatorComplete('registration');
  var isCourseComplete = course.isCurriculum ? isCourseFullyComplete : flowList.filter(function (f) {
    return mediatorProps.course.options.includes(f.handle) && f.isRequired && !f.isComplete;
  }).length === 0;
  var availableTabs = tabs.filter(function (tab) {
    return mediatorProps[tab] && mediatorProps[tab].toggle && (tab !== 'registration' || registration.isInternalRegistration || registration.isExternalRegistration);
  });

  /* since shortHash is optional second param, handle case where shortHash is missing
   * and second param is actually courseWrapperTab */
  var currTab = params.courseWrapperTab || availableTabs.find(function (t) {
    return t === params.shortHash;
  });
  /* One final check in case Course Wrapper is rendered on a custom app route
   * (not via DeploymentEvaluator) */
  if (!currTab && history !== null && history !== void 0 && (_history$location = history.location) !== null && _history$location !== void 0 && _history$location.pathname) {
    var search = history.location.pathname.search(_index.courseWrapperTabWhitelistRegex);
    if (search !== -1) {
      // remove beginning slash /
      currTab = history.location.pathname.slice(search + 1);
    }
  }
  var currentTabs = course.isCurriculum && course.curriculumTabStyle === 'side' ? getCurrentSideTabsCurriculum() : getCurrentTabs();
  var firstFlow = originalFlowList.length && originalFlowList[0];
  var relatedDeploymentId = firstFlow ? firstFlow.responseSet : null;

  /* /////////////////////////////////////////////////////////////////////////
  // LIFECYCLE METHODS //////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  (0, _react.useEffect)(function () {
    function getCurriculumData() {
      return _getCurriculumData.apply(this, arguments);
    }
    function _getCurriculumData() {
      _getCurriculumData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var mainResponse, mainProgress, deployments, repeatedResponses, deploymentsForCurriculum, deploymentIdsToFetch, newDeploymentsResp, newDeployments, mustTakeInOrder;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _cccisdApollo.client.query({
                query: _curriculumProgress["default"],
                variables: {
                  mainDeploymentId: curriculumRelatedDeploymentId,
                  deploymentIds: course.curriculumOptions.map(function (d) {
                    return d.deploymentId;
                  }),
                  actingPawnId: actingPawnId
                },
                fetchPolicy: 'network-only'
              });
            case 1:
              mainResponse = _context2.v;
              mainProgress = (0, _get2["default"])(mainResponse, 'data.mainAssignment.assignmentProgress', null);
              delete mainProgress.__typename;
              deployments = (0, _get2["default"])(mainResponse, 'data.flows.deploymentList', []) || []; // forceRenewable is backdoor JSON way to have repeatable curriculum without a certificate
              if (!(!isPreviewMode && (
              // If the whole curriculum is repeatable, or any individual deployment inside of it
              certificate.toggle && certificate.allowRenew || certificate.forceRenewable || deployments.some(function (d) {
                var _d$settings;
                return d === null || d === void 0 ? void 0 : (_d$settings = d.settings) === null || _d$settings === void 0 ? void 0 : _d$settings.isRepeated;
              })))) {
                _context2.n = 5;
                break;
              }
              _context2.n = 2;
              return Promise.all(course.curriculumOptions.map(function (_ref2) {
                var _deployments$find, _deployments$find$set;
                var parentDeploymentId = _ref2.deploymentId;
                var isRepeated = (_deployments$find = deployments.find(function (d) {
                  return Number(d.deploymentId) === Number(parentDeploymentId);
                })) === null || _deployments$find === void 0 ? void 0 : (_deployments$find$set = _deployments$find.settings) === null || _deployments$find$set === void 0 ? void 0 : _deployments$find$set.isRepeated;
                if (!isRepeated) {
                  return Promise.resolve({
                    data: {
                      data: {
                        deploymentId: parentDeploymentId
                      }
                    }
                  });
                }
                return _cccisdAxios["default"].get(Boilerplate.route('api.assignmentDeployment.repeated', {
                  deploymentId: parentDeploymentId,
                  pawnId: actingPawnId,
                  hash: actingPawnHash
                }), {
                  params: {
                    isPawnHash: true,
                    relatedDeploymentId: curriculumRelatedDeploymentId
                  }
                });
              }));
            case 2:
              repeatedResponses = _context2.v;
              deploymentsForCurriculum = [];
              deploymentIdsToFetch = [];
              repeatedResponses.forEach(/*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(resp) {
                  var _resp$data, _resp$data2, _resp$data3;
                  var data, deploymentId, deployment;
                  return _regenerator().w(function (_context) {
                    while (1) switch (_context.n) {
                      case 0:
                        if (resp !== null && resp !== void 0 && (_resp$data = resp.data) !== null && _resp$data !== void 0 && _resp$data.status && (resp === null || resp === void 0 ? void 0 : (_resp$data2 = resp.data) === null || _resp$data2 === void 0 ? void 0 : _resp$data2.status) !== 'success') {
                          console.error("Could not get repeatable deployment ID. Full error message: `".concat(resp.data.errors, "`"));
                        }
                        data = (resp === null || resp === void 0 ? void 0 : (_resp$data3 = resp.data) === null || _resp$data3 === void 0 ? void 0 : _resp$data3.data) || {};
                        deploymentId = data.deploymentId;
                        deployment = deployments.find(function (d) {
                          return d.deploymentId === deploymentId;
                        });
                        if (deployment) {
                          deploymentsForCurriculum.push(deployment);
                        } else if (deploymentId) {
                          deploymentIdsToFetch.push(deploymentId);
                        }
                      case 1:
                        return _context.a(2);
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref3.apply(this, arguments);
                };
              }());

              // cases where axios call created new timepoints, we now have to fetch them
              if (!(deploymentIdsToFetch.length > 0)) {
                _context2.n = 4;
                break;
              }
              _context2.n = 3;
              return _cccisdApollo.client.query({
                query: _curriculumResettableDeployments["default"],
                variables: {
                  deploymentIds: deploymentIdsToFetch,
                  actingPawnId: actingPawnId
                },
                fetchPolicy: 'network-only'
              });
            case 3:
              newDeploymentsResp = _context2.v;
              newDeployments = (0, _get2["default"])(newDeploymentsResp, 'data.flows.deploymentList', false);
              if (Array.isArray(newDeployments)) {
                newDeployments.forEach(function (dep) {
                  deploymentsForCurriculum.push(dep);
                });
              }
            case 4:
              // children deployments are created with isOpen as false, so force it here
              deployments = deploymentsForCurriculum.map(function (dep) {
                return _objectSpread(_objectSpread({}, dep), {}, {
                  isOpen: true
                });
              });
            case 5:
              mustTakeInOrder = (0, _get2["default"])(course, 'navigationSettings.mustTakeInOrder', false);
              setCurriculumProps({
                mainProgress: isPreviewMode ? {
                  started: false,
                  completed: false
                } : mainProgress,
                progress: deployments.map(function (dep, i) {
                  delete dep.__typename;
                  delete dep.assignment.__typename;
                  delete dep.assignmentProgress.__typename;
                  if (isPreviewMode) {
                    dep = _objectSpread(_objectSpread({}, dep), {}, {
                      assignmentProgress: {
                        started: false,
                        completed: false,
                        lastVisitedAt: ''
                      }
                    });
                  }
                  var options = course.curriculumOptions.find(function (d) {
                    return dep.parentDeploymentId ? dep.parentDeploymentId === d.deploymentId : dep.deploymentId === d.deploymentId;
                  });
                  return _objectSpread(_objectSpread(_objectSpread({}, options), dep), {}, {
                    isAllowed: !mustTakeInOrder || i === 0 || (0, _get2["default"])(deployments[i - 1], 'assignmentProgress.completed', false),
                    setProgress: function setProgress(started, completed) {
                      return setCurriculumDeploymentProgress(dep.deploymentId, started, completed);
                    }
                  });
                }).sort(function (a, b) {
                  var aIndex = course.curriculumOptions.findIndex(function (dep) {
                    return a.parentDeploymentId ? a.parentDeploymentId === dep.deploymentId : a.deploymentId === dep.deploymentId;
                  }) || -1;
                  var bIndex = course.curriculumOptions.findIndex(function (dep) {
                    return b.parentDeploymentId ? b.parentDeploymentId === dep.deploymentId : b.deploymentId === dep.deploymentId;
                  }) || -1;
                  return aIndex - bIndex;
                })
              });
            case 6:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return _getCurriculumData.apply(this, arguments);
    }
    if (course.toggle && course.isCurriculum && ['course', 'finalTest', 'certificate', 'courseEval'].includes(params === null || params === void 0 ? void 0 : params.courseWrapperTab)) {
      getCurriculumData();
    }
  }, [currTab, params.assignmentId]);
  (0, _react.useEffect)(function () {
    function forceComplete() {
      return _forceComplete.apply(this, arguments);
    }
    function _forceComplete() {
      _forceComplete = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              setHasCompletedLocally(true);
              setFinalTestStartedComplete(true);
              _context3.n = 1;
              return onAssignmentComplete();
            case 1:
              _context3.n = 2;
              return onComplete();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      return _forceComplete.apply(this, arguments);
    }
    if (curriculumProps && curriculumProps.progress && Array.isArray(curriculumProps.progress) && curriculumProps.progress.every(function (dep) {
      return !!dep.assignmentProgress.completed;
    }) && isCourseEvalComplete && isFinalTestComplete && !curriculumProps.mainProgress.completed) {
      // curriculum may not have any local flows that are completable, so
      // manually trigger it whenever all inner-deployments are complete
      forceComplete();
    }
  }, [curriculumProps]);
  (0, _react.useEffect)(function () {
    if (!isExternalRegistrationLoading && (!currTab || !availableTabs.includes(currTab))) {
      history.push("".concat(basePath, "/").concat(course.isCurriculum && course.curriculumTabStyle === 'side' ? currentTabs[0].tab : currentTabs[0]));
    }
    function checkExternalRegistration() {
      return _checkExternalRegistration.apply(this, arguments);
    }
    function _checkExternalRegistration() {
      _checkExternalRegistration = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var response, isComplete;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (!isPreviewMode) {
                _context4.n = 1;
                break;
              }
              setIsExternalRegistrationLoading(false);
              return _context4.a(2);
            case 1:
              if (registration.externalRegistrationDeploymentId) {
                _context4.n = 2;
                break;
              }
              setIsExternalRegistrationComplete(true);
              return _context4.a(2);
            case 2:
              _context4.n = 3;
              return _cccisdApollo.client.query({
                query: _externalRegistrationStatus["default"],
                variables: {
                  deploymentId: registration.externalRegistrationDeploymentId,
                  pawnId: actingPawnId
                },
                fetchPolicy: 'network-only'
              });
            case 3:
              response = _context4.v;
              isComplete = (0, _get2["default"])(response, 'data.flows.deployment.assignmentProgress.completed', false) || false;
              setIsExternalRegistrationComplete(isComplete);
              setIsExternalRegistrationLoading(false);
            case 4:
              return _context4.a(2);
          }
        }, _callee4);
      }));
      return _checkExternalRegistration.apply(this, arguments);
    }
    if (registration && registration.toggle && registration.isExternalRegistration && isExternalRegistrationLoading) {
      checkExternalRegistration();
    } else if (isExternalRegistrationLoading) {
      setIsExternalRegistrationLoading(false);
    }
  }, [isExternalRegistrationLoading]);
  (0, _react.useEffect)(function () {
    if (!hasVisitedCertificate && currTab === 'certificate' && isCourseComplete && isFinalTestComplete && isCourseEvalComplete) {
      setHasVisitedCertificate(true);
    }
  }, [currTab]);
  (0, _react.useEffect)(function () {
    function getFinalTestStatuses() {
      return _getFinalTestStatuses.apply(this, arguments);
    }
    function _getFinalTestStatuses() {
      _getFinalTestStatuses = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var result, finalTestSummary, date, isPassing, finalTestList, _t;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              if (!(!firstFlow || !finalTest || !finalTest.toggle || !finalTest.useRepeatingFinalTest)) {
                _context5.n = 1;
                break;
              }
              setFinalTestDataRetrievedCount(1);
              return _context5.a(2);
            case 1:
              _context5.p = 1;
              _context5.n = 2;
              return _cccisdApollo.client.query({
                query: _finalTestStatus["default"],
                fetchPolicy: 'network-only',
                variables: {
                  parentDeploymentId: finalTest.parentDeploymentId,
                  relatedDeploymentId: relatedDeploymentId,
                  pawnId: actingPawnId
                }
              });
            case 2:
              result = _context5.v;
              finalTestSummary = (0, _get2["default"])(result, 'data.flows.deployment.assignmentProgress.variables', null) || null;
              if (finalTestSummary) {
                date = finalTestSummary[Object.keys(finalTestSummary).find(function (k) {
                  return k.endsWith('_date');
                })];
                isPassing = !!parseInt(finalTestSummary[Object.keys(finalTestSummary).find(function (k) {
                  return k.endsWith('_pass');
                })], 10);
                finalTestSummary = {
                  date: date,
                  isPassing: isPassing
                };
                setLatestFinalTestData(function (prev) {
                  return _objectSpread(_objectSpread({}, prev), finalTestSummary);
                });
              }
              finalTestList = (0, _get2["default"])(result, 'data.flows.deploymentList', []) || [];
              setFinalTestData({
                summary: finalTestSummary,
                list: finalTestList
              });
              _context5.n = 4;
              break;
            case 3:
              _context5.p = 3;
              _t = _context5.v;
              console.error(_t);
              setFinalTestData({
                summary: null,
                list: []
              });
            case 4:
              if (finalTestDataRetrievedCount === 0) {
                setFinalTestDataRetrievedCount(1);
              }
            case 5:
              return _context5.a(2);
          }
        }, _callee5, null, [[1, 3]]);
      }));
      return _getFinalTestStatuses.apply(this, arguments);
    }
    if (finalTestDataRetrievedCount !== 1 && !isPreviewMode) {
      getFinalTestStatuses();
    }
    if (finalTestDataRetrievedCount === 0 && isPreviewMode) {
      setFinalTestDataRetrievedCount(1);
    }
  }, [finalTestDataRetrievedCount]);
  (0, _react.useEffect)(function () {
    function exceededTestMaxTries() {
      return _exceededTestMaxTries.apply(this, arguments);
    }
    function _exceededTestMaxTries() {
      _exceededTestMaxTries = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var resp, deployment, deploymentLastVisitedAt, testLastVisitedAt, testVisitedAfterDeployment;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              if (!(finalTest.useMaxTries && finalTest.maxTries)) {
                _context6.n = 3;
                break;
              }
              _context6.n = 1;
              return _cccisdApollo.client.query({
                query: _curriculumProgress["default"],
                variables: {
                  mainAssignmentHandle: handle,
                  deploymentIds: [relatedDeploymentId],
                  actingPawnId: actingPawnId
                },
                fetchPolicy: 'network-only'
              });
            case 1:
              resp = _context6.v;
              deployment = resp.data.flows.deploymentList.find(function (x) {
                return x.deploymentId === relatedDeploymentId;
              }); // Both times should be UTC
              deploymentLastVisitedAt = new Date(deployment.assignmentProgress.lastVisitedAt);
              testLastVisitedAt = new Date(latestFinalTestData.date);
              testVisitedAfterDeployment = (0, _dateFns.isAfter)(testLastVisitedAt, deploymentLastVisitedAt);
              if (!(latestFinalTestData.timepoint >= finalTest.maxTries && testVisitedAfterDeployment)) {
                _context6.n = 2;
                break;
              }
              setLatestFinalTestData(function (prev) {
                return _objectSpread(_objectSpread({}, prev), {}, {
                  exceededMaxTries: true,
                  recentlyExceededMaxTries: true // Never gets set to false, once set. So we can use to not navigate back to final test on every assignment lastVisitedAt update
                });
              });
              return _context6.a(2, true);
            case 2:
              setLatestFinalTestData(function (prev) {
                return _objectSpread(_objectSpread({}, prev), {}, {
                  exceededMaxTries: false
                });
              });
              return _context6.a(2, false);
            case 3:
              setLatestFinalTestData(function (prev) {
                return _objectSpread(_objectSpread({}, prev), {}, {
                  exceededMaxTries: false
                });
              });
              return _context6.a(2, false);
          }
        }, _callee6);
      }));
      return _exceededTestMaxTries.apply(this, arguments);
    }
    exceededTestMaxTries();
  }, [finalTest, latestFinalTestData.date, latestFinalTestData.timepoint, params, relatedDeploymentId]);

  /* /////////////////////////////////////////////////////////////////////////
  // GENERAL METHODS ////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  var setCurriculumDeploymentProgress = function setCurriculumDeploymentProgress(deploymentId, started, completed) {
    setCurriculumProps(function (prev) {
      // manually set assignment started_at for the main deployment
      // if there are no flows that triggered it already
      function setMainStarted() {
        return _setMainStarted.apply(this, arguments);
      }
      function _setMainStarted() {
        _setMainStarted = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
          return _regenerator().w(function (_context7) {
            while (1) switch (_context7.n) {
              case 0:
                _context7.n = 1;
                return onFlowStarted({
                  handle: ''
                });
              case 1:
                return _context7.a(2);
            }
          }, _callee7);
        }));
        return _setMainStarted.apply(this, arguments);
      }
      var mainProgress = prev.mainProgress;
      if (!prev.mainProgress.started && (started || completed)) {
        mainProgress = Object.assign({}, mainProgress, {
          started: true
        });
        setMainStarted();
      }
      var progress = _toConsumableArray(prev.progress);
      var index = progress.findIndex(function (dep) {
        return dep.deploymentId === deploymentId;
      });
      progress[index].assignmentProgress = {
        started: started,
        completed: completed
      };
      if ((0, _get2["default"])(course, 'navigationSettings.mustTakeInOrder', false) && index < progress.length - 1 && completed) {
        progress[index + 1].isAllowed = true;
      }
      return {
        mainProgress: mainProgress,
        progress: progress
      };
    });
  };
  function determineCurriculumStatus() {
    if (!course || !course.toggle || !course.isCurriculum || course.curriculumOptions.length === 0) {
      return true;
    }
    if (!(curriculumProps !== null && curriculumProps !== void 0 && curriculumProps.progress)) {
      return false;
    }
    return curriculumProps.progress.every(function (deployment) {
      var deploymentOpen = (0, _get2["default"])(deployment, 'isOpen', false);
      var deploymentCompleted = (0, _get2["default"])(deployment, 'assignmentProgress.completed', false) || false;
      return !deploymentOpen || deploymentCompleted;
    });
  }
  function determineFinalTestStatus() {
    if (!finalTest || !finalTest.toggle) {
      return true;
    }
    if (finalTestDataRetrievedCount > 1 && isPreviewMode) {
      return true;
    }
    if (finalTestDataRetrievedCount === 0) {
      return false;
    }
    var isPassing = false;
    if (finalTestData.summary) {
      isPassing = finalTestData.summary.isPassing;
    }
    if (finalTestData.list.length === 0) {
      if (isPassing) {
        return true;
      }
      if (finalTestStartedComplete) {
        setFinalTestStartedComplete(false);
      }
      return false;
    }
    var latestData = {};

    /* flag to make sure assignmentProgress only fires once instead of once for every attempt */
    var tryingAssignmentComplete = false;
    var _iterator = _createForOfIteratorHelper(finalTestData.list),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var ftData = _step.value;
        if (!(0, _get2["default"])(ftData, 'assignmentProgress.completed')) {
          continue;
        }
        var variables = (0, _get2["default"])(ftData, 'assignmentProgress.variables', {});
        var numCorrect = Object.values(variables).filter(function (v) {
          return typeof v === 'string' && v.toLowerCase() === 'correct';
        }).length;
        var numIncorrect = Object.values(variables).filter(function (v) {
          return typeof v === 'string' && v.toLowerCase() === 'incorrect';
        }).length;
        var denominator = numCorrect + numIncorrect;
        if (denominator === 0) {
          ftData.score = 0;
          continue;
        }
        ftData.score = numCorrect / denominator * 100;
        ftData.numCorrect = numCorrect;
        ftData.numTotal = denominator;
        ftData.passing = isPassing;
        // prevent race condition where assignment_test_pass is not calculated and
        // saved by the time finalTestData is fetched
        if (!ftData.passing && finalTest.passingThreshold && ftData.score >= Number(finalTest.passingThreshold)) {
          ftData.passing = true;
          isPassing = true;
        }
        ftData.completionDate = finalTestData && finalTestData.date ? finalTestData.date : null;
        // if courseEval is ON, it will be marked complete when that is finised via onFlowCompleteLocal
        if (isPassing && !finalTestStartedComplete && !tryingAssignmentComplete && !courseEval.toggle) {
          tryingAssignmentComplete = true;
          tryAssignmentComplete({
            finalTestComplete: true
          });
        }
        latestData = _objectSpread({}, ftData);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (latestFinalTestData.deploymentId !== latestData.deploymentId) {
      setLatestFinalTestData(function (prev) {
        return _objectSpread(_objectSpread({}, prev), latestData);
      });
    }
    if (!isPassing && finalTestStartedComplete) {
      setFinalTestStartedComplete(false);
    }
    return isPassing;
  }
  function getCurrentSideTabsCurriculum() {
    var newTabs = [];
    tabs.forEach(function (tab) {
      switch (tab) {
        case 'courseDescription':
          if (courseDescription.toggle) {
            newTabs.push({
              tab: tab,
              tabName: courseDescription.tabName
            });
          }
          break;
        case 'registration':
          if (registration.toggle && (registration.isInternalRegistration || registration.isExternalRegistration)) {
            newTabs.push({
              tab: tab,
              tabName: registration.tabName,
              isComplete: isRegistrationComplete,
              isDisabled: isRegistrationComplete,
              isLocked: false
            });
          }
          break;
        case 'course':
          if (course.toggle) {
            newTabs.push({
              tab: tab,
              tabName: course.tabName,
              isComplete: isCourseFullyComplete,
              isDisabled: !course.allowRetake && isCourseFullyComplete || !isRegistrationComplete,
              isLocked: !isRegistrationComplete
            });
          }
          break;
        case 'finalTest':
          if (finalTest.toggle) {
            newTabs.push({
              tab: tab,
              tabName: finalTest.tabName,
              isComplete: isFinalTestComplete,
              isDisabled: latestFinalTestData.exceededMaxTries || finalTest.lockedUntilCompletion && !isCourseFullyComplete || isFinalTestComplete,
              isLocked: finalTest.lockedUntilCompletion && !isCourseFullyComplete || latestFinalTestData.exceededMaxTries
            });
          }
          break;
        case 'courseEval':
          if (courseEval.toggle) {
            newTabs.push({
              tab: tab,
              tabName: courseEval.tabName,
              isComplete: isCourseEvalComplete,
              isDisabled: (!isCourseFullyComplete || !isFinalTestComplete) && courseEval.lockedUntilCompletion || isCourseEvalComplete,
              isLocked: (!isCourseFullyComplete || !isFinalTestComplete) && courseEval.lockedUntilCompletion
            });
          }
          break;
        case 'certificate':
          if (certificate.toggle) {
            newTabs.push({
              tab: tab,
              tabName: certificate.tabName,
              isComplete: false,
              isDisabled: !isCourseFullyComplete || !isFinalTestComplete || !isCourseEvalComplete,
              isLocked: !isCourseFullyComplete || !isFinalTestComplete || !isCourseEvalComplete
            });
          }
          break;
        case 'resources':
          if (resources.toggle) {
            newTabs.push({
              tab: tab,
              tabName: resources.tabName,
              isComplete: false,
              isDisabled: resources.lockedUntilCompletion && !isCourseFullyComplete,
              isLocked: resources.lockedUntilCompletion && !isCourseFullyComplete
            });
          }
          break;
        default:
        //
      }
    });
    return newTabs;
  }
  function getCurrentTabs() {
    var newTabs = [];

    // First Tab
    if (courseDescription && courseDescription.toggle) {
      newTabs.push('courseDescription');
    }

    // Second Tab
    var showRegistration = showExternalRegistrationDeployment;
    if (registration && registration.toggle && registration.isInternalRegistration) {
      var registrationSurveys = flowList.filter(function (f) {
        return registration.options.includes(f.handle) && !f.isComplete;
      });
      if (registrationSurveys.length) {
        showRegistration = true;
      }
    }
    if (showRegistration) {
      newTabs.push('registration');
    }
    if (!newTabs.includes('registration')) {
      newTabs.push('course');
    }

    // Third Tab
    var thirdTab = getThirdTab();
    if (thirdTab) {
      newTabs.push(thirdTab);
    }

    // Fourth Tab
    if (resources && resources.toggle) {
      if (!isCourseComplete && resources.lockedUntilCompletion) {
        newTabs.push('resources_locked');
      } else {
        newTabs.push('resources');
      }
    }
    return newTabs;
  }
  function getThirdTab() {
    var thirdTab;
    if (finalTest && finalTest.toggle) {
      thirdTab = 'finalTest';
      if (!isFinalTestComplete && finalTest.lockedUntilCompletion) {
        if (!isCourseComplete) {
          thirdTab = 'finalTest_locked';
        }
        if (latestFinalTestData.exceededMaxTries) {
          thirdTab = 'finalTest_locked';
        }
      }
    }
    if (courseEval && courseEval.toggle && isFinalTestComplete) {
      thirdTab = 'courseEval';
      if (!isCourseEvalComplete && courseEval.lockedUntilCompletion) {
        if (!isCourseComplete) {
          thirdTab = 'courseEval_locked';
        }
      }
    }
    if (certificate && certificate.toggle && isFinalTestComplete && isCourseEvalComplete) {
      if (!isCourseComplete) {
        thirdTab = 'certificate_locked';
      } else {
        thirdTab = 'certificate';
      }
    }
    return thirdTab;
  }
  function isTabMediatorComplete(tabKey) {
    if (tabKey === 'course' && course.isCurriculum) {
      return determineCurriculumStatus();
    }
    if (tabKey === 'finalTest' && finalTest && finalTest.useRepeatingFinalTest) {
      return determineFinalTestStatus();
    }
    if (tabKey === 'registration' && showExternalRegistrationDeployment) {
      return false;
    }
    var isComplete = true;
    if (mediatorProps[tabKey] && mediatorProps[tabKey].toggle && (tabKey !== 'registration' || registration.isInternalRegistration)) {
      isComplete = flowList.filter(function (f) {
        return mediatorProps[tabKey].options.includes(f.handle) && !f.isComplete;
      }).length === 0;
    }
    return isComplete;
  }
  function getMediatorTabData() {
    var onCompleteLocations = getOnCompleteLocations();
    var getMustCompleteString = function getMustCompleteString(must, before) {
      return "You must first complete the ".concat(must, " before starting the ").concat(before, ".");
    };
    var getAlreadyCompletedString = function getAlreadyCompletedString(tab) {
      if (tab.completionMessage) {
        return /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
          content: tab.completionMessage
        });
      }
      return "You have already completed the ".concat(tab.tabName, ".");
    };
    var courseLockedMessage = function courseLockedMessage() {
      if (isRegistrationComplete) {
        return null;
      }
      return course.isCurriculum ? /*#__PURE__*/_react["default"].createElement("span", null, "You must first complete the", ' ', /*#__PURE__*/_react["default"].createElement(_cccisdReactRouter.NavLink, {
        to: basePath + '/registration'
      }, registration.tabName), " before starting the", ' ', course.tabName, ".") : getMustCompleteString(registration.tabName, course.tabName);
    };
    var courseEvalLockedMessage = function courseEvalLockedMessage() {
      if (!isCourseComplete) {
        if (finalTest.toggle) {
          return getMustCompleteString("".concat(course.tabName, " and ").concat(finalTest.tabName), courseEval.tabName);
        }
        return getMustCompleteString(course.tabName, courseEval.tabName);
      }
      if (finalTest.toggle && !isFinalTestComplete) {
        return getMustCompleteString(finalTest.tabName, courseEval.tabName);
      }
      return null;
    };
    return {
      course: {
        completedMessage: isCourseFullyComplete && !course.allowRetake ? getAlreadyCompletedString(course) : null,
        lockedMessage: courseLockedMessage(),
        onCompleteLocation: onCompleteLocations.course
      },
      courseEval: {
        completedMessage: isCourseEvalComplete ? getAlreadyCompletedString(courseEval) : null,
        lockedMessage: courseEvalLockedMessage(),
        onCompleteLocation: onCompleteLocations.courseEval
      },
      finalTest: {
        completedMessage: isFinalTestComplete ? getAlreadyCompletedString(finalTest) : null,
        lockedMessage: !isCourseComplete && finalTest.lockedUntilCompletion ? getMustCompleteString(course.tabName, finalTest.tabName) : null,
        onCompleteLocation: latestFinalTestData.exceededMaxTries ? onCompleteLocations.registration : onCompleteLocations.finalTest
      },
      registration: {
        completedMessage: isRegistrationComplete ? getAlreadyCompletedString(registration) : null,
        onCompleteLocation: onCompleteLocations.registration
      }
    };
  }
  function getOnCompleteLocations() {
    var courseOnComplete = '';
    if (finalTest.toggle && !isFinalTestComplete) {
      courseOnComplete = 'finalTest';
    } else if (courseEval.toggle && !isCourseEvalComplete) {
      courseOnComplete = 'courseEval';
    } else if (certificate.toggle && !hasVisitedCertificate) {
      courseOnComplete = 'certificate';
    }
    var finalTestOnComplete = '';
    if (courseEval.toggle) {
      finalTestOnComplete = 'courseEval';
    } else if (certificate.toggle) {
      finalTestOnComplete = 'certificate';
    }
    var courseEvalOnComplete = certificate.toggle ? 'certificate' : '';
    var addFullPath = function addFullPath(path) {
      if (!path) {
        return null;
      }
      return "".concat(basePath, "/").concat(path);
    };
    return {
      registration: addFullPath('course'),
      course: latestFinalTestData.recentlyExceededMaxTries ? addFullPath('course') : addFullPath(courseOnComplete),
      finalTest: addFullPath(finalTestOnComplete),
      courseEval: addFullPath(courseEvalOnComplete)
    };
  }
  function onClickTab(tabKey) {
    history.push("".concat(basePath, "/").concat(tabKey));
  }
  function onFlowCompleteLocal(_x2) {
    return _onFlowCompleteLocal.apply(this, arguments);
  }
  function _onFlowCompleteLocal() {
    _onFlowCompleteLocal = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(flow) {
      var completionInfo,
        _args9 = arguments;
      return _regenerator().w(function (_context9) {
        while (1) switch (_context9.n) {
          case 0:
            completionInfo = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : {};
            return _context9.a(2, new Promise(/*#__PURE__*/function () {
              var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(resolve) {
                var updatedFlowList, subMediatorData;
                return _regenerator().w(function (_context8) {
                  while (1) switch (_context8.n) {
                    case 0:
                      if (!flow.isComplete) {
                        flow.completedLocally = true;
                      }
                      flow.isComplete = true;
                      updatedFlowList = [].concat(_toConsumableArray(flowList.filter(function (f) {
                        return f.handle !== flow.handle;
                      })), [flow]).sort(sortByOrdinalPosition);
                      setFlowList(updatedFlowList);
                      _context8.n = 1;
                      return onFlowComplete(flow, completionInfo);
                    case 1:
                      _context8.n = 2;
                      return tryAssignmentComplete({
                        updatedFlowList: updatedFlowList
                      });
                    case 2:
                      subMediatorData = getMediatorTabData()[currTab];
                      if (['registration', 'course', 'courseEval', 'finalTest'].includes(currTab) && isTabMediatorComplete(currTab) && subMediatorData.onCompleteLocation) {
                        history.push(subMediatorData.onCompleteLocation);
                      }
                      return _context8.a(2, resolve());
                  }
                }, _callee8);
              }));
              return function (_x5) {
                return _ref5.apply(this, arguments);
              };
            }()));
        }
      }, _callee9);
    }));
    return _onFlowCompleteLocal.apply(this, arguments);
  }
  function onFlowStartedLocal(_x3) {
    return _onFlowStartedLocal.apply(this, arguments);
  }
  function _onFlowStartedLocal() {
    _onFlowStartedLocal = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(flow) {
      var updatedFlowList;
      return _regenerator().w(function (_context0) {
        while (1) switch (_context0.n) {
          case 0:
            flow.isStarted = true;
            _context0.n = 1;
            return onFlowStarted(flow);
          case 1:
            updatedFlowList = [].concat(_toConsumableArray(flowList.filter(function (f) {
              return f.handle !== flow.handle;
            })), [flow]).sort(sortByOrdinalPosition);
            setFlowList(updatedFlowList);
          case 2:
            return _context0.a(2);
        }
      }, _callee0);
    }));
    return _onFlowStartedLocal.apply(this, arguments);
  }
  function sortByOrdinalPosition(e1, e2) {
    if (e1.ordinalPosition < e2.ordinalPosition) {
      return -1;
    }
    if (e1.ordinalPosition > e2.ordinalPosition) {
      return 1;
    }
    return 0;
  }
  function tryAssignmentComplete(_x4) {
    return _tryAssignmentComplete.apply(this, arguments);
  }
  function _tryAssignmentComplete() {
    _tryAssignmentComplete = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(_ref4) {
      var finalTestComplete, _ref4$updatedFlowList, updatedFlowList, localIsFinalTestComplete, localFlowList, isLocalFlowsComplete, isAllFlowsComplete;
      return _regenerator().w(function (_context1) {
        while (1) switch (_context1.n) {
          case 0:
            finalTestComplete = _ref4.finalTestComplete, _ref4$updatedFlowList = _ref4.updatedFlowList, updatedFlowList = _ref4$updatedFlowList === void 0 ? null : _ref4$updatedFlowList;
            localIsFinalTestComplete = finalTestComplete || isFinalTestComplete;
            localFlowList = updatedFlowList || flowList;
            isLocalFlowsComplete = localFlowList.every(function (f) {
              return f.isComplete || !f.isRequired;
            });
            isAllFlowsComplete = isLocalFlowsComplete && (!course.isCurriculum || isCourseFullyComplete);
            if (!(!hasCompletedLocally && (!startedComplete || !finalTestStartedComplete) && isAllFlowsComplete && (!isRepeatedFinalTest || localIsFinalTestComplete))) {
              _context1.n = 2;
              break;
            }
            setHasCompletedLocally(true);
            setFinalTestStartedComplete(true);
            _context1.n = 1;
            return onAssignmentComplete();
          case 1:
            _context1.n = 2;
            return onComplete();
          case 2:
            return _context1.a(2);
        }
      }, _callee1);
    }));
    return _tryAssignmentComplete.apply(this, arguments);
  }
  return {
    availableTabs: availableTabs,
    currentTabs: currentTabs,
    currTab: currTab,
    curriculumProps: curriculumProps,
    flowList: flowList,
    isCourseComplete: isCourseComplete,
    isCourseEvalComplete: isCourseEvalComplete,
    isFinalTestComplete: isFinalTestComplete,
    isLoading: isExternalRegistrationLoading,
    isRegistrationComplete: isRegistrationComplete,
    isRepeatedFinalTest: isRepeatedFinalTest,
    isTabMediatorComplete: isTabMediatorComplete,
    latestFinalTestData: latestFinalTestData,
    mediatorTabData: getMediatorTabData(),
    onClickTab: onClickTab,
    onExternalRegistrationComplete: function onExternalRegistrationComplete() {
      setIsExternalRegistrationCompleteLocally(true);
      if (!registration.isInternalRegistration || registration.options.length === 0) {
        history.push("".concat(basePath, "/course"));
      }
    },
    onFinalTestComplete: function onFinalTestComplete() {
      setFinalTestDataRetrievedCount(finalTestDataRetrievedCount + 1);
    },
    onFlowCompleteLocal: onFlowCompleteLocal,
    onFlowStartedLocal: onFlowStartedLocal,
    relatedDeploymentId: relatedDeploymentId,
    setFlowList: setFlowList,
    showExternalRegistrationDeployment: showExternalRegistrationDeployment
  };
};
useCourseWrapperMediator.propTypes = {
  actingPawnId: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  basePath: _propTypes["default"].string,
  isPreviewMode: _propTypes["default"].bool,
  mediatorProps: _propTypes["default"].object,
  onAssignmentComplete: _propTypes["default"].func,
  onFlowComplete: _propTypes["default"].func,
  onFlowStarted: _propTypes["default"].func,
  originalFlowList: _propTypes["default"].array.isRequired
};
var _default = exports["default"] = useCourseWrapperMediator;